import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="site-footer" style={{ background: '#0f2b18', color: '#e8f5ee' }}>
      <div className="container" style={{ display: 'grid', gap: 24, padding: '36px 20px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <img src="/images/logo.png" alt="SIDES" width={28} height={28} loading="lazy" />
              <strong style={{ fontSize: 16, letterSpacing: 0.2 }}>SIDES Mercado</strong>
            </div>
            <p style={{ margin: 0, color: '#b6d5c4' }}>Plataforma Digital Sustentável</p>
          </div>

          <nav aria-label="Links úteis" style={{ display: 'flex', gap: 18, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <Link to="/sobre" style={{ color: '#e8f5ee' }}>Sobre</Link>
            <Link to="/ajuda" style={{ color: '#e8f5ee' }}>Ajuda</Link>
            <Link to="/termos" style={{ color: '#e8f5ee' }}>Termos</Link>
            <Link to="/privacidade" style={{ color: '#e8f5ee' }}>Privacidade</Link>
          </nav>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, alignItems: 'start' }}>
          <div>
            <h4 style={{ margin: '0 0 8px 0', fontSize: 14, color: '#9fd9b8' }}>Contacto</h4>
            <p style={{ margin: 0, color: '#cfe9db' }}>
              📧 <a href="mailto:info@govurb.co.mz" style={{ color: '#cfe9db' }}>info@govurb.co.mz</a><br />
              📞 <a href="https://wa.me/258852620360" target="_blank" rel="noreferrer" style={{ color: '#cfe9db' }}>+258 85 262 0360</a>
            </p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <small style={{ color: '#9ccfb5' }}>© {year} SIDES Mercado</small>
          </div>
        </div>
      </div>
    </footer>
  )
}
